import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type {
	FormFieldDefinitionModel,
	FormRuleModel,
} from '../../forms/form-types';
import { BaseEntity } from './base.entity';
import { FormEntity } from './form.entity';

/**
 * One version of a form's fields and rules, written whenever either changes. Submissions
 * point at the version they were made against, so an old submission always reads with the
 * labels, options and consent text its submitter saw, without copying the definition into
 * every submission row.
 */
@Index('UK_form_version_form_version', ['fkFormId', 'version'], {
	unique: true,
})
@Entity('form_version')
export class FormVersionEntity extends BaseEntity {
	@Column('int', { name: 'fk_form__id', unsigned: true })
	public fkFormId!: number;

	@Column('int', { name: 'version', unsigned: true })
	public version!: number;

	// The active fields in display order, exactly as the page showed them.
	@Column('json', { name: 'fields' })
	public fields!: Array<FormFieldDefinitionModel>;

	@Column('json', { name: 'rules', nullable: true })
	public rules!: Array<FormRuleModel> | null;

	// Tenant-local user who made the change; null when a migration or the system wrote it.
	@Column('int', {
		name: 'fk_user__id_createdBy',
		nullable: true,
		unsigned: true,
	})
	public fkUserIdCreatedBy!: number | null;

	@ManyToOne(() => FormEntity, { createForeignKeyConstraints: false })
	@JoinColumn([{ name: 'fk_form__id', referencedColumnName: 'id' }])
	public form!: FormEntity;
}
